import React from "react";
import { Select, Input, Button, Row, Col, Form, Spin } from "antd";
import { theme } from "../../../utils/theme";
import useCommonsService from "../../../services/useCommonsService";
import { useNavigate } from "react-router-dom";
import PageRoutes from "../../../utils/routes";
export function HomePageSearchPart({}) {
  const navigate = useNavigate();
  const { cities, isGetCitiesLoading, useGetLabelKeys } = useCommonsService();
  const { data: labelKeys, isLoading: isLabelKeysLoading } = useGetLabelKeys();
  const [form] = Form.useForm();

  if (isGetCitiesLoading || isLabelKeysLoading) {
    return <Spin spinning={true}></Spin>;
  }

  const handleSearch = (values) => {
    const { city, searchQuery } = values;

    navigate(PageRoutes.listings, {
      state: { searchQuery: searchQuery, cityId: city },
    });
  };

  const handleQuickSearch = (labelKey) => {
    navigate(PageRoutes.listings, {
      state: { labelKey: labelKey },
    });
  };

  const labelKeysToShow = [...labelKeys.slice(5, 7), ...labelKeys.slice(8, 12)];
  return (
    <div
      style={{
        padding: "20px 40px 30px",
        textAlign: "center",
        backgroundColor: theme.mainPageSearchColor,
      }}>
      {/* Title and Job Count */}
      <h2
        style={{
          fontSize: "36px",
          marginBottom: "8px",
        }}>
        Kariyer Fırsatlarını Keşfet
      </h2>
      <p
        style={{
          fontSize: "22px",
          color: "gray",
        }}>
        77.412 iş ilanı on binlerce şirket
      </p>

      {/* Search Inputs and Button */}
      <Form form={form} onFinish={handleSearch}>
        <Row
          gutter={16}
          style={{
            justifyContent: "center",
            marginBottom: "16px",
          }}>
          <Col xs={24} sm={10} lg={6}>
            <Form.Item name="city">
              <Select
                allowClear
                placeholder="Şehir"
                options={cities}
                style={{
                  width: "100%",
                  height: "45px",
                  // Increased height
                  marginBottom: "8px",
                }}>
                {/* Add more cities */}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={10} lg={6}>
            <Form.Item name="searchQuery">
              <Input
                placeholder="Pozisyon veya Anahtar Kelime"
                style={{
                  height: "45px",
                  marginBottom: "8px",
                }}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={4} lg={4}>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                width: "100%",
                height: "45px", // Match the height of Input and Select
              }}>
              İş Bul
            </Button>
          </Col>
        </Row>
      </Form>

      {/* Popular Categories */}
      <div>
        <p
          style={{
            fontSize: "14px",
            marginBottom: "8px",
            fontWeight: "bold",
          }}>
          Popüler Kategoriler
        </p>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap",
          }}>
          {labelKeysToShow.map((item, index) => {
            return (
              <Button
                key={index}
                onClick={() => {
                  handleQuickSearch(item.value);
                }}
                type="default"
                style={{
                  margin: "5px",
                }}>
                {item.label}
              </Button>
            );
          })}

          {/* Add more categories */}
        </div>
      </div>
    </div>
  );
}
